import template from './index.pug'

export default Vue.extend({
  name: 'privacy-policiy-page',
  template: template(),
  created() {
    window.scrollTo(0, 0)
  }
})
